<div class="modal-header" id="barcode-clipboard-modal-title">
    <h3 class="modal-title" id="modal-title" translate="BARCODE_CLIPBOARD_SET_TITLE"></h3>
    <span class="close" (click)="hideModal()">&times;</span>
</div>
<div class="modal-body" id="modal-body">
    <form [formGroup]="addBarcodeForm">
        <div class="row mb-3">
            <div class="col-12 col-md-3 d-flex justify-content-md-end">
                <label
                    class="col-form-label text-nowrap"
                    for="barcodeInput"
                    translate="BARCODE_CLIPBOARD_LABEL_BARCODE"
                ></label>
            </div>
            <div class="col-10 col-md-5">
                <pace-core-text-input
                    id="barcodeInput"
                    name="barcodeInput"
                    [parentForm]="formChildren"
                    [(model)]="barcodeTextModel"
                    [barcodeClipboardAccessible]="false"
                    [attr.aria-label]="'BARCODE_CLIPBOARD_LABEL_BARCODE' | translate"
                ></pace-core-text-input>
            </div>
        </div>
        <div class="row mb-3">
            <div class="col-12 col-md-3 d-flex justify-content-md-end">
                <label
                    class="col-form-label text-nowrap"
                    for="barcodeLabelInput"
                    translate="BARCODE_CLIPBOARD_LABEL_LABEL"
                ></label>
            </div>
            <div class="col-10 col-md-5">
                <pace-core-text-input
                    id="barcodeLabelInput"
                    name="barcodeLabelInput"
                    [parentForm]="formChildren"
                    [(model)]="labelTextModel"
                    [attr.aria-label]="'BARCODE_CLIPBOARD_LABEL_LABEL' | translate"
                ></pace-core-text-input>
            </div>
            <div class="col-2 ms-md-auto">
                <button
                    id="btnMaterialAdd"
                    type="button"
                    class="btn btn-primary float-end"
                    translate="BARCODE_CLIPBOARD_LABEL_BUTTON_ADD"
                    [disabled]="addBarcodeForm.invalid"
                    (click)="addBarcode()"
                ></button>
            </div>
        </div>
    </form>
    <div>
        <lib-pace-barcode-clipboard
            [barcodes]="(barcodes$ | async) ?? []"
            [pickableBarcodes]="false"
            [deletableBarcodes]="true"
            [pickTitle]="'BARCODE_CLIPBOARD_PICK' | translate"
            [deleteTitle]="'BARCODE_CLIPBOARD_DELETE' | translate"
            [qrBackLabel]="'BARCODE_CLIPBOARD_LABEL_QR_BACK' | translate"
            [mismatchTooltip]="'BARCODE_MISSMATCH_PATTERN_TOOLTIP' | translate"
            (barcodeUpdates)="barcodeUpdates.next($event)"
        ></lib-pace-barcode-clipboard>
    </div>
</div>
